module.exports = __webpack_public_path__ + "img/3.67445551.jpg";